import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getEmployeeStatus = async () => {
  const { data } = await axios.get(
    `${api_base_url}/EmployeeConfiguration/EmployeeStatus`
  );

  return data;
};

export const getEmployeeStatusFilter = async () => {
  const { data } = await axios.get(
    `${api_base_url}/EmployeeConfiguration/EmployeeStatusFilter`
  );

  return data;
};

// Insert New EmployeeStatus
export const addEmployeeStatus = async (newEmployeeStatus) => {
  const { data } = await axios.post(
    `${api_base_url}/EmployeeConfiguration/EmployeeStatus`,
    {
      ...newEmployeeStatus[0],
    }
  );
  return data;
};
// Update EmployeeStatus

export const updateEmployeeStatus = async (updatedEmployeStatus) => {
  const { data } = await axios.put(
    `${api_base_url}/EmployeeConfiguration/EmployeeStatus${updatedEmployeStatus[0].employeeStatusId}`,
    updatedEmployeStatus[0]
  );
  return data;
};

export const deleteEmployeeStatus = async (ids) => {
  await axios.delete(`${api_base_url}/EmployeeConfiguration/EmployeeStatus`, {
    data: ids,
  });
};
